module.exports = __webpack_public_path__ + "img/myposition_fb_아슈라프 하키미.0f0cf231.png";